// extracted by mini-css-extract-plugin
module.exports = {"container":"SmUzFHoF","icon":"QAJnPqXd","iconDisabled":"lRcdyzHw","sparkles":"aQaEqx2U","sparklesBullish":"RuBt5SxC","sparklesBearish":"tFnLxt5J","sparklesDisabled":"DvYKf240"};